/**
 * Meu RQC — onde o pedido caiu e em que etapa está cada item (ADR-0074).
 * Somente consulta: quem trata o RQC é o comprador, na fila de Compras.
 */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FiArrowLeft, FiDownload } from "react-icons/fi";

import { useAuth } from "../../../context/AuthContext";
import { listarMeusRqc } from "../../../services/rqc";
import { SITUACAO_TONE } from "../../../services/requisicoesCompraUi";
import { SITUACAO_ITEM_LABEL, SITUACAO_ITEM_TONE } from "../../../services/compras";
import { PageContainer, PageTitle, PageTopBar } from "../../../styles/shared";
import { formatarDataLocal, formatarQuantidade } from "../../../utils/dinheiro";
import { Carregando } from "../_shared/Estados";
import { Card, ErroBox, Hint, Label, Pill, SolMeta } from "./styles";

export default function RqcDetalhe() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { request } = useAuth();
  const [rqc, setRqc] = useState(undefined);
  const [erro, setErro] = useState("");

  useEffect(() => {
    listarMeusRqc(request)
      .then((lista) => setRqc((lista || []).find((r) => r.id === id) || null))
      .catch((e) => setErro(e?.message || "Não foi possível carregar o RQC."));
  }, [request, id]);

  return (
    <PageContainer style={{ maxWidth: 760 }}>
      <PageTopBar>
        <button type="button" className="btn btn--secondary btn--sm" onClick={() => navigate("../..")} aria-label="Voltar">
          <FiArrowLeft size={14} />
        </button>
        <PageTitle>Requisição de Compras (RQC)</PageTitle>
      </PageTopBar>

      {erro ? <ErroBox>{erro}</ErroBox> : null}
      {!erro && rqc === undefined ? <Carregando /> : null}
      {!erro && rqc === null ? <ErroBox>RQC não encontrado.</ErroBox> : null}

      {rqc ? (
        <div style={{ display: "grid", gap: 16 }}>
          <Card>
            <SolMeta>
              <span>Enviado em {formatarDataLocal(rqc.created_at)}</span>
              {rqc.requisicao ? (
                <>
                  <span>Requisição {rqc.requisicao.numero}</span>
                  <Pill $tone={SITUACAO_TONE[rqc.requisicao.situacao] || "neutral"}>{rqc.requisicao.situacao_label}</Pill>
                </>
              ) : <span>Requisição excluída pelo Compras</span>}
            </SolMeta>
            <SolMeta>
              <span>{rqc.motivo_label}</span>
              <span>Precisa até {formatarDataLocal(rqc.data_necessaria)}</span>
              {rqc.prioridade === "URGENTE" ? <Pill $tone="danger">Urgente</Pill> : null}
            </SolMeta>
            {rqc.prioridade === "URGENTE" ? <Hint>Urgência: {rqc.motivo_urgencia}</Hint> : null}
            <div style={{ fontSize: 14 }}>{rqc.justificativa}</div>
          </Card>

          <Card>
            <Label as="div">Itens</Label>
            {rqc.itens.map((it, i) => (
              <div key={`${it.nome}-${i}`} style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0, fontSize: 14 }}>
                <span style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={it.nome}>{it.nome}</span>
                <span>×{formatarQuantidade(it.quantidade)} {it.unidade}</span>
                <Pill $tone={SITUACAO_ITEM_TONE[it.situacao] || "neutral"}>{SITUACAO_ITEM_LABEL[it.situacao] || it.situacao_label}</Pill>
              </div>
            ))}
          </Card>

          {rqc.anexos.length ? (
            <Card>
              <Label as="div">Anexos</Label>
              {rqc.anexos.map((a) => (
                <a key={a.id} href={a.url || undefined} target="_blank" rel="noreferrer" style={{ fontSize: 13, display: "inline-flex", gap: 6, alignItems: "center" }}>
                  <FiDownload size={13} /> {a.nome}
                </a>
              ))}
            </Card>
          ) : null}
        </div>
      ) : null}
    </PageContainer>
  );
}
